import { render } from "./FullscreenButton.vue?vue&type=template&id=66689544&scoped=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=js"
export * from "./FullscreenButton.vue?vue&type=script&lang=js"

import "./FullscreenButton.vue?vue&type=style&index=0&id=66689544&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66689544"]])

export default __exports__